<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>{{ $t('MaintenanceView.title') }}</h6>
          <p class="font13 gray-col">
            {{ $t('MaintenanceView.subtitle') }}
          </p>
        </div>
      </div>
      <div class="manage-account-tabs">
        <ul class="nav nav-tabs mb-3" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="firstTap"
              data-bs-toggle="tab"
              data-bs-target="#firstTapcontent"
              type="button"
              role="tab"
              aria-controls="firstTapcontent"
              aria-selected="true"
            >
              {{ $t('MaintenanceView.new') }}
            </button>
          </li>
          <li class="nav-item" @click="getFinishedOrders" role="presentation">
            <button
              class="nav-link"
              id="thirdTap"
              data-bs-toggle="tab"
              data-bs-target="#thirdTapcontent"
              type="button"
              role="tab"
              aria-controls="thirdTapcontent"
              aria-selected="false"
            >
              {{ $t('MaintenanceView.finished') }}
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <!--جديدة-->
          <div
            class="tab-pane fade show active"
            id="firstTapcontent"
            role="tabpanel"
            aria-labelledby="firstTapcontent-tab"
          >
            <div v-if="!loader">
              <dataTable
                :tableData="filteredNewOrders"
                :showLink="true"
                :HeadOfTable="HeadOfTable"
                linkDirection="MaintenanceDetails"
              />
            </div>
            <div class="loader-main-axios" v-else>
              <div>{{ $t('MaintenanceView.loadingData') }}</div>
              <div class="spinner-small-white"></div>
            </div>
          </div>
          <!--منتهية-->
          <div
            class="tab-pane fade"
            id="thirdTapcontent"
            role="tabpanel"
            aria-labelledby="thirdTapcontent-tab"
          >
            <div v-if="!loader">
              <dataTable
                :tableData="filteredFinishedOrders"
                :showLink="true"
                :HeadOfTable="HeadOfTable"
                linkDirection="MaintenanceDetails"
              />
            </div>
            <div class="loader-main-axios" v-else>
              <div>{{ $t('MaintenanceView.loadingData') }}</div>
              <div class="spinner-small-white"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import dataTable from "../components/dashboard/dataTable.vue";
import { useI18n } from "vue-i18n";
import { ref, onMounted, computed } from "vue";
import { useStore } from 'vuex';

const { t } = useI18n();
const store = useStore();

// reactive state
const HeadOfTable = ref([
  {
    headText: t('MaintenanceView.serialNumber'),
    headKey: "id",
  },
  {
    headText: t('MaintenanceView.orderNumber'),
    headKey: "id",
  },
  {
    headText: t('MaintenanceView.buildingName'),
    headKey: "name",
  },
  {
    headText: t('MaintenanceView.tenantName'),
    headKey: "user.name",
  },
  {
    headText: t('MaintenanceView.requestType'),
    headKey: "maintenance_type.name",
  },
  {
    headText: t('MaintenanceView.technicianName'),
    headKey: "worker.name",
  },
  {
    headText: t('MaintenanceView.orderDate'),
    headKey: "created_at",
  },
]);

// computed properties
const filteredNewOrders = computed(() => store.getters.filteredNewMaintenanceOrders);
const filteredFinishedOrders = computed(() => store.getters.filteredFinishedMaintenanceOrders);
const loader = computed(() => store.getters.isLoading);
// const searchValue = computed(() => store.getters.searchValue);

// functions
const getNewOrders = () => {
  store.dispatch('fetchNewMaintenanceOrders');
};

const getFinishedOrders = () => {
  store.dispatch('fetchFinishedMaintenanceOrders');
};

// lifecycle hooks
onMounted(() => {
  getNewOrders();
});
</script>
